import React from 'react';
import './Footer.css';
import logo from '../assets/images/logo.png';

const Footer = ({ onOpenModal }) => {

  return (
    <footer className="footer" id="contatti">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-brand">
              <div className="footer-logo-container">
                <img src={logo} alt="ZeroInfezioni" className="footer-logo-img" />
                <h3 className="footer-logo">ZeroInfezioni</h3>
              </div>
              <p className="footer-tagline">Servizi di cybersicurezza</p>
              <p className="footer-description">
                <span className="highlight-yellow">Soluzione antivirus italiana</span>, conforme al GDPR, 
                progettato per proteggere la tua attività dalle <span className="highlight-yellow">costanti minacce informatiche</span>.
              </p>
              <div className="footer-website">
                <span>Visita il nostro sito: </span>
                <a href="https://zeroinfezioni.it" target="_blank" rel="noopener noreferrer">
                  🌐 zeroinfezioni.it
                </a>
              </div>
            </div>
          </div>

          <div className="footer-section">
            <h4 className="footer-title">Prodotti</h4>
            <ul className="footer-links">
              <li><a href="#piani">Piano Sentinella</a></li>
              <li><a href="#piani">Piano Sicuro</a></li>
              <li><a href="#piani">Piano Inviolato</a></li>
              <li><a href="#piani">Soluzioni Enterprise</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-title">Supporto</h4>
            <ul className="footer-links">
              <li><a href="#caratteristiche">Guida Installazione</a></li>
              <li><a href="#faq">Domande Frequenti</a></li>
              <li><a href="#contatti">Supporto Tecnico 24/7</a></li>
              <li><a href="#aggiornamenti">Aggiornamenti</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-title">Azienda</h4>
            <ul className="footer-links">
              <li><a href="#chi-siamo">Chi Siamo</a></li>
              <li><a href="#tecnologia">La Nostra Tecnologia</a></li>
              <li><a href="#privacy">Privacy Policy</a></li>
              <li><a href="#gdpr">Conformità GDPR</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-title">Contatti</h4>
            <div className="footer-contact">
              <div className="contact-item">
                <span className="contact-icon">📧</span>
                <a href="mailto:info@zeroinfezioni.it">info@zeroinfezioni.it</a>
              </div>
              <div className="contact-item">
                <span className="contact-icon">📞</span>
                <a href="tel:+390212345678">+39 02 1234 5678</a>
              </div>
              <div className="contact-item">
                <span className="contact-icon">💬</span>
                <a href="#contatti">Chat Live 24/7</a>
              </div>
              <div className="contact-item">
                <span className="contact-icon">🇮🇹</span>
                <span>Supporto in Italiano</span>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <div className="footer-copyright">
              <p>&copy; 2025 ZeroInfezioni Srl. Tutti i diritti riservati.</p>
              <p className="footer-gdpr">Conforme al GDPR • Privacy dei dati garantita • Sviluppato in Italia</p>
            </div>
            <div className="footer-cta">
              <button className="btn btn-primary" onClick={onOpenModal}>
                Scarica Ora Gratis
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 